/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Import_Dashboard_TitleInputs */



/**
* | output |
* | --- |
* | "Shot Description Import" |
*
* @param {Scene_Description_Import_Dashboard_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_dashboard_title = /** @type {((inputs?: Scene_Description_Import_Dashboard_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_Dashboard_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du plan Importer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Shot Description Import")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione dello scatto Importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание кадра Импорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de la descripción de la toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头描述导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの説明インポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição da tomada Importação")
	return /** @type {LocalizedString} */ ("Shot Description Import")
});